"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = exports.CLOSE_BUTTON_ALIGNMENTS = void 0;
var DEFAULT_STYLE = {
  Z_INDEX: 12,
  HEIGHT: '85%',
  ANIMATION_DURATION: 0.5,
  OVERLAY_BG_COLOR: 'black',
  OVERLAY_OPACITY: '0.8'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;
var CLOSE_BUTTON_ALIGNMENTS = ['left', 'right'];
exports.CLOSE_BUTTON_ALIGNMENTS = CLOSE_BUTTON_ALIGNMENTS;